module.exports = __webpack_public_path__ + "img/INTJ.978f258c.png";